// Uses Bootstraps carousel and its `slid.bs.carousel` event.
(function($) {
    $('.slider--thumbnails').on('slid.bs.carousel', function(e) {
        var _this = $(this);
        var indicator = _this.find('.carousel-indicators');
        var activeIndicator = _this.find('.carousel-indicators .active');

        // Get the current offsets compared to the left side of the document.
        var indicatorCenter = indicator.offset().left + (indicator.width() / 2);
        var itemCenter = activeIndicator.offset().left + (activeIndicator.width() / 2);

        // Calculate scroll value for the indicator element.
        var offset = itemCenter - indicatorCenter;

        // Set scroll value of the indicator element.
		indicator.animate({
            scrollLeft: indicator.scrollLeft() + offset
        });
    });
})(jQuery);
